import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'operationClassification',
    title: 'Operation Classification',
    filter: 'text',
    width: 150
  },
  {
    field: 'operationName',
    title: 'Operation Step Name',
    filter: 'text',
    width: 150
  },
  {
    field: 'startTimeShow',
    title: 'Start',
    filter: 'text',
    width: 150
  },
  {
    field: 'warning',
    title: 'Warning',
    filter: 'text',
    width: 150
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 80
  }
];



// WEBPACK FOOTER //
// ./src/pages/validation/multi-day/multi-day.config.ts